module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[93]336.5b5ab3d.woff2";